import { Routes } from '@angular/router';

export const MAGENTY_SALE_CHANNEL_ROUTES: Routes = [
  {
    path: '',
    loadComponent: async () =>
      (await import('../features/shell/shell.component')).ShellComponent
  },
  {
    path: '**',
    pathMatch: 'full',
    loadComponent: async () =>
      (await import('../features/shell/shell.component')).ShellComponent
  }
];
